import React from 'react';
import { Col } from 'react-bootstrap';
import PhotoGallery from '../../components/PhotoGallery/PhotoGallery';

const PhotoGalleries = () => (<div className="styles-section row" id="photo-galleries">
  <Col sm={12} className='main-page-title'>
    <h3>Photo Galleries</h3>
  </Col>
  <Col sm={12} className='home-page-content'>
    <PhotoGallery xs={1} sm={2} lg={4} userId={1} platform={'instagram'} />
  </Col>
  <Col sm={12} className='home-page-content'>
    <PhotoGallery xs={1} sm={2} lg={4} userId={1} platform={'instagram'} headerMode />
  </Col>

  <Col sm={12} className='home-page-content'>
    <PhotoGallery xs={1} sm={2} lg={4} userId={2} platform={'instagram'} headerMode quantity={8}/>
  </Col>
</div>);

export default PhotoGalleries;